import { apiUrl } from './api';

export const fmtViews = (n) => {
    if (!n) return '0';
    const num = Number(n);
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
    if (num >= 1_000)     return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
    return String(num);
};

export const fmtNum = (n) => {
    if (!n) return '0';
    return Number(n).toLocaleString('ru-RU');
};

export const buildPosterUrl = (posterUrl) => {
    if (!posterUrl) return '';
    if (/^https?:\/\//i.test(posterUrl)) return posterUrl;
    return apiUrl(posterUrl);
};

export const fmtDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now  = new Date();
    const diff = now - date;
    const h = 3_600_000;
    const d = 86_400_000;
    if (diff < h)        return 'только что';
    if (diff < 2 * h)    return '1 час назад';
    if (diff < d)        return `${Math.floor(diff / h)} ч назад`;
    if (diff < 2 * d)    return 'вчера';
    if (diff < 7 * d)    return `${Math.floor(diff / d)} дн назад`;
    if (diff < 30 * d)   return `${Math.floor(diff / (7 * d))} нед назад`;
    if (diff < 365 * d)  return `${Math.floor(diff / (30 * d))} мес назад`;
    return `${Math.floor(diff / (365 * d))} г назад`;
};

export const fmtDuration = (val) => {
    if (!val) return '';
    if (typeof val === 'string' && val.includes(':')) return val;
    const s   = parseInt(val, 10);
    const min = Math.floor(s / 60);
    const sec = s % 60;
    return `${min}:${String(sec).padStart(2, '0')}`;
};
